export default __webpack_public_path__ + "./images/ng.5d31b81b.png";